<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <jm-toolbar customize-field-name="student">
          <el-button slot="beforeDefinedSearch" type="primary" @click="handleAdd">
            添加菜单
          </el-button>
        </jm-toolbar>

        <div class="table-tree">
          <vxe-table
            :auto-resize="true"
            resizable
            show-overflow
            row-id="id"
            ref="menuTreeTable"
            v-loading="loading"
            :tree-config="{ expandAll: true }"
            :row-config="{ isHover: true }"
            :data="menuData">
            <vxe-column field="id" title="Id" width="50"></vxe-column>
            <vxe-column field="title" title="名称" min-width="250" tree-node></vxe-column>
            <vxe-column field="sort" title="排序" width="50"></vxe-column>
            <vxe-column field="group" title="分组" min-width="150"></vxe-column>
            <vxe-column field="group_limit_field" title="必填参数" min-width="100"></vxe-column>
            <vxe-column field="url" title="系统路由" min-width="200"></vxe-column>
            <vxe-column field="rule_url" title="权限URL" min-width="200"></vxe-column>
            <vxe-column field="hide" title="隐藏" width="80">
              <template #default="{ row }">
                <el-tag size="small" type="danger" v-if="row.hide === 1">隐藏</el-tag>
                <el-tag size="small" type="success" v-else>显示</el-tag>
              </template>
            </vxe-column>
            <vxe-column field="status" title="访问限制" width="80">
              <template #default="{ row }">
                <el-tag size="small" type="" v-if="row.status === 1">允许</el-tag>
                <el-tag size="small" type="warning" v-else>禁止</el-tag>
              </template>
            </vxe-column>
            <vxe-column field="lastColumn" title="操作" min-width="200" fixed="right">
              <template #default="{ row }">
                <el-button
                  size="small"
                  type="primary"
                  @click="handleEdit(row)">编辑</el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="handleDelete(row)">删除</el-button>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
      </div>
      <!--编辑弹层 S-->
      <el-dialog
        :title="formData.id ? '编辑菜单' : '新增菜单'"
        class="dialog"
        :visible.sync="dialogVisible"
      >
        <div class="form-wrapper">
          <el-form
            ref="formData"
            :rules="rules"
            :model="formData"
            label-width="150px">
            <el-form-item label="上级目录">
              <!-- <template v-if="formData.id">
                {{ fullMenuTitle }}
              </template> -->
              <el-tooltip effect="dark" :content="fullMenuTitle" :disabled="!fullMenuTitle">
                <el-cascader
                  clearable
                  :disabled="false"
                  class="jm-input280"
                  v-model="formData.parentIds"
                  :change-on-select="true"
                  :options="formOptions"
                  @change="handelChange">
                </el-cascader>
              </el-tooltip>
            </el-form-item>

            <el-form-item label="名称" prop="title">
              <el-input class="jm-input280" v-model="formData.title" />
            </el-form-item>
            <el-form-item label="系统路由">
              <el-input class="jm-input280" v-model="formData.url"/>
            </el-form-item>
            <el-form-item label="权限URL">
              <el-input class="jm-input280" v-model="formData.rule_url"/>
            </el-form-item>
            <el-form-item label="同级排序">
              <el-input class="jm-input280" v-model="formData.sort"/>
            </el-form-item>
            <el-form-item label="导航分组">
              <el-input class="jm-input280" v-model="formData.group"/>
            </el-form-item>
            <el-form-item label="分组必要字段">
              <el-input class="jm-input280" v-model="formData.group_limit_field"/>
            </el-form-item>
            <el-form-item label="菜单隐藏">
              <el-switch
                active-text="隐藏"
                inactive-text="显示"
                :active-value="1"
                :inactive-value="0"
                v-model="formData.hide"/>
            </el-form-item>
            <el-form-item label="访问限制">
              <el-switch
                active-text="允许"
                inactive-text="禁止"
                :active-value="1"
                :inactive-value="0"
                v-model="formData.status"/>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm('formData')">{{ formData.id ? '保存' : '创建' }}菜单</el-button>
            <!--<el-button @click="resetForm('ruleForm')">重置</el-button>-->
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!--编辑弹层 E-->
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import xeUtils from 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';

Vue.use(VXETable);

export default {
  data() {
    return {
      loading: false,
      sliderMaxWidth: 2000, // 相当于表格宽度，可以计算获取
      sliderVal: 0,
      menuData: [],
      searchData: {
        pid: this.$route.params.pid,
      },
      dialogVisible: false,
      formData: {
        parentIds: []
      },
      formOptions: [],
      rules: {
        title: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
  computed: {
    ...mapGetters([
      'onlineDict',
    ]),
    fullMenuTitle() {
      return this.getMenuTitle(this.formData.pid);
    }
  },
  methods: {
    handelChange(val) {
      if (val.length) {
        this.formData.parentIds = val;
        this.formData.pid = val[val.length - 1];
      } else {
        this.formData.parentIds = [0];
        this.formData.pid = 0;
      }
    },
    findMenuItem(id) {
      return xeUtils.findTree(this.menuData, item => item.id === id);
    },
    fetchMenu () {
      this.loading = true;
      this.dialogVisible = false;
      this.$http._post({
        url: '/interview/Power/menu',
        data: {},
      }).then(({ data }) => {
        this.menuData = data;
        this.$nextTick(() => {
          this.$refs.menuTreeTable.setAllTreeExpand(true);
          this.loading = false;
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    handleAdd() { // 添加
      this.formData = {
        pid: 0, parentIds: []
      };
      this.formOptions = this.getMenuOptions(null);
      this.dialogVisible = true;
    },
    handleEdit(row) { // 编辑
      this.formData = Object.assign({ parentIds: row.path }, row);
      this.formOptions = this.getMenuOptions(this.formData.id);
      this.dialogVisible = true;
    },
    handleDelete(row) { // 删除
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/interview/Power/menuDel',
          data: { id: row.id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({ type: 'success', message: '菜单删除成功!' });
            this.fetchMenu();
          }
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    submitForm(formName) {
      const parentIds = this.formData.parentIds;
      this.formData.pid = parentIds[parentIds.length - 1];
      this.formData.id
        ? this.submitFormEdit(formName)
        : this.submitFormAdd(formName);
    },
    submitFormAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (typeof this.formData.pid === 'undefined') {
            this.formData.pid = 0;
          }
          this.$http._post({
            url: '/interview/Power/menuAdd',
            data: this.formData,
          }).then((res) => {
            if (res.result === 0) {
              this.$message({ type: 'success', message: '菜单创建成功!' });
              this.fetchMenu();
            }
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
    submitFormEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将永久改变该菜单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http._post({
              url: '/interview/Power/menuEdit',
              data: this.formData,
            }).then((res) => {
              if (res.result === 0) {
                this.$message({ type: 'success', message: '菜单编辑成功!' });
                this.fetchMenu();
              }
            });
          }).catch(() => {
            this.$message({ type: 'info', message: '已取消编辑' });
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
    getMenuItem(menu, disabledId) {
      let result = {
        value: menu.id,
        label: menu.title,
        disabled: menu.id === disabledId
      };

      if (menu.children && menu.children.length > 0) {
        const children = menu.children.map(m => this.getMenuItem(m, disabledId));
        result = Object.assign({ children: children }, result);
      }
      return result;
    },
    getMenuTitle(pid) {
      const title = '顶层菜单';

      if (!pid) {
        return title;
      }

      const menuItem = this.findMenuItem(pid);
      if (menuItem.nodes) {
        return [title, ...menuItem.nodes.map(m => m.title)].join(' / ');
      }
      return '';
    },
    getMenuOptions(disabledId) {
      return [
        this.getMenuItem({ id: 0, title: '顶层菜单', children: this.menuData }, disabledId)
      ];
    },
  },
  mounted() {
    this.fetchMenu();
  },
};
</script>
<style>
.form-wrapper {
  padding: 20px 20px 1px 20px;
  position: relative;
}
</style>
